<template>
    <div>
        <div class="form-control">
            <label for="cf_nome_completo">Nome completo*:</label>
            <input id="cf_nome_completo" name="cf_nome_completo" required="true">
        </div>
        <div class="form-control">
            <label for="cf_email">E-mail*:</label>
            <input id="cf_email" name="cf_email" type="email" v-model="dadosPessoais.email" required @input="validateEmail"
                @blur="validateEmail">
            <span v-if="emailError" class="error-message" style="color:red;">{{ emailError }}</span>
        </div>
        <div class="form-control">
            <label for="cf_estado_civil">Estado civil*:</label>
            <select name="cf_estado_civil" id="cf_estado_civil" required="true" v-model="dadosPessoais.estado_civil">
                <option value=""></option>
                <option value="casado">Casado</option>
                <option value="divorciado">Divorciado</option>
                <option value="solteiro">Solteiro</option>
                <option value="uniao_estavel">União estável</option>
                <option value="Viúvo">Viúvo</option>
            </select>
        </div>
        <!-- {{form.estado_civil}} -->
        <div class="form-control" v-if="dadosPessoais.estado_civil == 'casado'">
            <label for="cf_data_do_casamento">Data do casamento*:</label>
            <input id="cf_data_do_casamento" name="cf_data_do_casamento" type="date" v-model="dadosPessoais.data_do_casamento"
                required @input="validateDataCasamento" @blur="validateDataCasamento">
            <span v-if="dataCasamentoError" class="error-message" style="color:red;">{{ dataCasamentoError }}</span>
        </div>
        <div class="form-control">
            <label for="cf_grau_de_instrucao">Grau de instrução*:</label>
            <select name="cf_grau_de_instrucao" id="cf_grau_de_instrucao" required="true">
                <option value=""></option>
                <option value="ensino fundamental incompleto">Ensino fundamental incompleto</option>
                <option value="ensino fundamental completo">Ensino fundamental completo</option>
                <option value="ensino medio incompleto">Ensino médio incompleto</option>
                <option value="ensino medio completo">Ensino médio completo</option>
                <option value="ensino superior incompleto">Ensino superior incompleto</option>
                <option value="ensino superior completo">Ensino superior completo</option>
                <option value="pos graduação/especialização">Pós-graduação/especialização</option>
                <option value="mestrado">Mestrado</option>
                <option value="doutorado">Doutorado</option>
                <option value="pos doutorado">Pós-doutorado</option>
            </select>
        </div>
        <div class="form-control">
            <label for="cf_sexo">Sexo*:</label>
            <select name="cf_sexo" id="cf_sexo" required="true" v-model="dadosPessoais.sexo">
                <option value=""></option>
                <option value="F">Feminino</option>
                <option value="M">Masculino</option>
            </select>
        </div>
        <div class="form-control">
            <label for="cf_cor_da_pele">Cor da pele*:</label>
            <select name="cf_cor_da_pele" id="cf_cor_da_pele" required="true">
                <option value=""></option>
                <option value="branca">Branca</option>
                <option value="negra">Negra</option>
                <option value="amarela">Amarela</option>
                <option value="indígena">Indígena</option>
                <option value="parda">Parda</option>
            </select>
        </div>
        <div class="form-control">
            <label for="cf_aposentado">Aposentado?</label>
            <select name="cf_aposentado" id="cf_aposentado" required="true" v-model="dadosPessoais.aposentado">
                <option value="sim">Sim</option>
                <option value="nao" selected>Não</option>
            </select>
        </div>
        <div class="form-control">
            <label for="cf_pcd">Possui deficiência?</label>
            <select name="cf_pcd" id="cf_pcd" required="true" v-model="dadosPessoais.pcd">
                <option value="sim">Sim</option>
                <option value="nao" selected>Não</option>
            </select>
        </div>
    </div>
</template>
<script>
import { mask } from 'vue-the-mask'
import mixins from '@/assets/mixins'

export default {
    directives: { mask },
    mixins: [mixins],
    created() {
    },
    data: () => ({

        //ufs: null,
        //municipios: null,
        estado_civil: '',
        pcd: '',
        aposentado: '',
        sexo: '',
        emailError: "",
        dataCasamentoError: "",

    }),
    props: {
        dadosPessoais: Object
    },
    beforeCreate() {

        //Carrega os estados       
        var interval = setInterval(() => {
            this.ufs = this.$store.state.ufs;

            if (this.ufs != null) {
                clearInterval(interval);
            }
        }, 1000)

        var interval2 = setInterval(() => {
            this.municipios = this.$store.state.municipios;

            if (this.municipios != null) {
                clearInterval(interval2);
            }
        }, 1000)

    },
    methods: {
        validateEmail() {
            const email = this.dadosPessoais.email ? this.dadosPessoais.email.trim() : "";
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!email) {
                this.emailError = "O e-mail é obrigatório.";
                return false
            } else if (!regex.test(email)) {
                this.emailError = "Por favor, insira um e-mail válido.";
                return false;
            } else {
                this.emailError = "";
                return true;
            }
        },
        validateDataCasamento() {
            const dataStr = this.dadosPessoais.data_do_casamento;
            if (!dataStr) {
                this.dataCasamentoError = "A data do casamento é obrigatória.";
                return;
            }
            const data = new Date(dataStr);
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);
            if (isNaN(data.getTime())) {
                this.dataCasamentoError = "Data inválida.";
            } else if (data > hoje) {
                this.dataCasamentoError = "A data do casamento não pode ser futura.";
            } else {
                this.dataCasamentoError = "";
            }
        },
        load_municipios(el) {

            var uf = el.target.value;
            var id_uf = null;

            //Loop in all uf's to find id uf
            for (const el_uf in this.ufs) {
                if (uf == this.ufs[el_uf].sigla) {
                    id_uf = this.ufs[el_uf].id;
                }
            }

            if (!id_uf) {
                alert('Erro ao carregar as uf\'s');
                return false;
            }

            this.axios
                .get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${id_uf}/municipios`)
                .then(response => {

                    //Check if status that's ok!
                    if (response.status == 200) {
                        this.municipios = this.orderStr(response.data, 'nome');
                    } else {
                        alert('Erro ao carregar as uf\'s');
                    }
                })
        }
    }
}
</script>